import * as React from 'react';
import UserDesignView from '../layouts/UnderDesignView';
// import { RowDataLive } from 'src/reducers/liveorderfile';
import { RowDataManufactur } from 'src/reducers/manufactur';
// import { UserDetail } from '../../reducers/user';

export interface UserDesignViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    // onSubmit: () => void;
    // onFilesChange: () => void;
    // onFilesError: () => void;
    // btnElement: string;
    // btnType: string;
    // userDetails: UserDetail;
    underDesignData: RowDataManufactur[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (filepath: string, fileName: string) => void;
}

class UserDesignPage extends React.Component<UserDesignViewProps> {
    render() {
        return (
            <UserDesignView
                onRowClick={this.props.onRowClick}
                underDesignData={this.props.underDesignData}
                reload={this.props.reload}
                onDownloadClick={this.props.onDownloadClick}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }

}

export default UserDesignPage;



// WEBPACK FOOTER //
// ./src/components/UnderDesign/UnderDesignPage.tsx